/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_NameInputs */

const en_support_form_name = /** @type {(inputs: Support_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name`)
};

const id_support_form_name = /** @type {(inputs: Support_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama kamu`)
};

/**
* | output |
* | --- |
* | "Your name" |
*
* @param {Support_Form_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_name = /** @type {((inputs?: Support_Form_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_name(inputs)
	return en_support_form_name(inputs)
});